export const ANIMATION_STATES = {
    NONE: '',
    OPEN: 'open',
    CLOSE: 'close',
} as const;
